<!-- eslint-disable max-len -->
<template>
  <div
    :style="{
      width: width,
      color: backgroundColor,
      'padding-bottom': (choice && choice.sliderDisplayValueOnThumb && !(choice.sliderHideValue) && !(choice.sliderLabelsBelow))
        ? '20px'
        : undefined,
      'padding-top':
        (thumbDisplayValueFlippedRootStyleFix)
          ? thumbDisplayValueFlippedRootStyleFix
          : undefined,
    }"
  >
    <div
      v-if="shouldDisplayIntervals && isTimeSlider"
      style="position: absolute;"
    >
      <div :style="`margin-top: 50px; width: ${width}; display: flex; justify-content: space-between; padding-left: 9px; padding-right: 9px;`">
        <div v-for="(time, idx) in displayTimes" :key="idx"
          :style="`height: 40px; width: 0px; border: 1px solid ${backgroundColor};`"
        >
          <div style="height: 40px;"/>
          <h5 style="text-align: center; margin-left: -20px; width: 40px;">{{time}}</h5>
        </div>
      </div>
    </div>
    <div :style="`width: ${width};`">
      <template v-if="displayValueOnTop && !(choice && (choice.sliderHideValue || choice.sliderDisplayValueOnThumb))">
        <div
          style="
            display: flex;
            justify-content: space-between;
          "
          :style="{
            width: width,
            height: titleHeight,
            'margin-bottom':
              (choice && choice.sliderDisplayValueOnThumb && !(choice.sliderHideValue) && choice.sliderLabelsBelow)
              ? '34px'
              : '5px',
          }"
        >
          <h4 :style="`text-align: ${titleAlign};`" v-html="title"></h4>
          <h4 :class="`${currency ? 'currency' : ''}`">{{valueString}}</h4>
        </div>
      </template>
      <template v-else>
        <h4
          :style="{
            width: width,
            height: titleHeight,
            'text-align': titleAlign,
            'margin-bottom':
              (choice && choice.sliderDisplayValueOnThumb && !(choice.sliderHideValue) && choice.sliderLabelsBelow)
              ? '34px'
              : '5px',
          }"
          v-html="title"
        ></h4>
      </template>
      <div v-if="
          choice
          && (choice.sliderMaxLabel || choice.sliderMidLabel || choice.sliderMinLabel
            || choice.sliderMaxImage || choice.sliderMidImage || choice.sliderMinImage)
          && !(choice.sliderLabelsBelow)
        "
        :style="`width: ${width}; height: ${titleHeight}; display: flex; justify-content: space-between; margin-bottom: 5px;'`"
      >
        <div v-if="choice.sliderMinImage"
          style="
            width: 33.33%;
            display: flex;
            flex-flow: row nowrap;
            justify-content: flex-start;
            align-items: flex-end;
          "
          :style="{
            'max-height': choice.sliderLabelRowMaxHeight || undefined,
          }"
        >
          <img class="label-image" :src="resolveAssetPath(choice.sliderMinImage, 'images')" />
        </div>
        <h5 v-else style="width: 33.33%; text-align: left;" v-html="choice.sliderMinLabel"></h5>
        <div v-if="choice.sliderMidImage"
          style="
            width: 33.34%;
            display: flex;
            flex-flow: row nowrap;
            justify-content: center;
            align-items: flex-end;
          "
          :style="{
            'max-height': choice.sliderLabelRowMaxHeight || undefined,
          }"
        >
          <img class="label-image" :src="resolveAssetPath(choice.sliderMidImage, 'images')" />
        </div>
        <h5 v-else style="width: 33.34%; text-align: center;" v-html="choice.sliderMidLabel"></h5>
        <div v-if="choice.sliderMaxImage"
          style="
            width: 33.33%;
            display: flex;
            flex-flow: row nowrap;
            justify-content: flex-end;
            align-items: flex-end;
          "
          :style="{
            'max-height': choice.sliderLabelRowMaxHeight || undefined,
          }"
        >
          <img class="label-image" :src="resolveAssetPath(choice.sliderMaxImage, 'images')" />
        </div>
        <h5 v-else style="width: 33.33%; text-align: right;" v-html="choice.sliderMaxLabel"></h5>
      </div>
      <div v-if="choice && choice.sliderLabelTicks"
        :style="`width: ${width}; height: 0; display: flex; justify-content: space-between;'`"
      >
        <div
          style="width: 0; height: 35px; border: 2px solid #82CFD0; border-radius: 4px; margin: -7px 0 0 12px;"
          :style="{
            visibility: (choice.sliderMinImage || choice.sliderMinLabel) ? undefined : 'hidden',
          }"
        ></div>
        <div
          style="width: 0; height: 35px; border: 2px solid #82CFD0; border-radius: 4px; margin: -7px 0 0 0;"
          :style="{
            visibility: (choice.sliderMidImage || choice.sliderMidLabel) ? undefined : 'hidden',
          }"
        ></div>
        <div
          style="width: 0; height: 35px; border: 2px solid #82CFD0; border-radius: 4px; margin: -7px 12px 0 0;"
          :style="{
            visibility: (choice.sliderMaxImage || choice.sliderMaxLabel) ? undefined : 'hidden',
          }"
        ></div>
      </div>
      <div v-if="choice && choice.sliderDisplayValueOnThumb && !(choice.sliderHideValue) && choice.sliderLabelsBelow"
        :style="`width: ${width}; height: 0; position: relative;'`"
      >
        <div
          class="thumb-display-value flip"
          :style="thumbDisplayValueStyle"
        >
          <span v-if="choice.sliderDisplayValuePrefix" v-html="choice.sliderDisplayValuePrefix" />
          {{valueString}}
          <span v-if="choice.sliderDisplayValueSuffix" v-html="choice.sliderDisplayValueSuffix" />
        </div>
      </div>
      <input
        ref="choiceSlider"
        class="colored-slider"
        :class="{ 'no-thumb-or-fill': noThumbOrFill }"
        :style="`width: ${width}; ${notRounded ? 'border-radius: 0px;' : ''} ${sliderStyle}`"
        type="range"
        :min="minValue"
        :max="maxValue"
        :step="shouldDisplayIntervals ? displayInterval : undefined"
        v-model="intermediateValue"
        @input="() => handleSliderInput()"
        @click="(ev) => $emit('click', ev)"
      />
      <div v-if="choice && choice.sliderDisplayValueOnThumb && !(choice.sliderHideValue) && !(choice.sliderLabelsBelow)"
        :style="`width: ${width}; height: 0; position: relative;'`"
      >
        <div
          class="thumb-display-value"
          :style="thumbDisplayValueStyle"
        >
          <span v-if="choice.sliderDisplayValuePrefix" v-html="choice.sliderDisplayValuePrefix" />
          {{valueString}}
          <span v-if="choice.sliderDisplayValueSuffix" v-html="choice.sliderDisplayValueSuffix" />
        </div>
      </div>
      <div v-if="
          choice
          && (choice.sliderMaxLabel || choice.sliderMidLabel || choice.sliderMinLabel
            || choice.sliderMaxImage || choice.sliderMidImage || choice.sliderMinImage)
          && choice.sliderLabelsBelow
        "
        :style="`width: ${width}; height: ${titleHeight}; display: flex; justify-content: space-between; margin-top: 5px;'`"
      >
        <div v-if="choice.sliderMinImage"
          style="
            width: 33.33%;
            display: flex;
            flex-flow: row nowrap;
            justify-content: flex-start;
            align-items: flex-end;
          "
          :style="{
            'max-height': choice.sliderLabelRowMaxHeight || undefined,
          }"
        >
          <img class="label-image" :src="resolveAssetPath(choice.sliderMinImage, 'images')" />
        </div>
        <h5 v-else style="width: 33.33%; text-align: left;" v-html="choice.sliderMinLabel"></h5>
        <div v-if="choice.sliderMidImage"
          style="
            width: 33.34%;
            display: flex;
            flex-flow: row nowrap;
            justify-content: center;
            align-items: flex-end;
          "
          :style="{
            'max-height': choice.sliderLabelRowMaxHeight || undefined,
          }"
        >
          <img class="label-image" :src="resolveAssetPath(choice.sliderMidImage, 'images')" />
        </div>
        <h5 v-else style="width: 33.34%; text-align: center;" v-html="choice.sliderMidLabel"></h5>
        <div v-if="choice.sliderMaxImage"
          style="
            width: 33.33%;
            display: flex;
            flex-flow: row nowrap;
            justify-content: flex-end;
            align-items: flex-end;
          "
          :style="{
            'max-height': choice.sliderLabelRowMaxHeight || undefined,
          }"
        >
          <img class="label-image" :src="resolveAssetPath(choice.sliderMaxImage, 'images')" />
        </div>
        <h5 v-else style="width: 33.33%; text-align: right;" v-html="choice.sliderMaxLabel"></h5>
      </div>
      <div style="position: absolute; margin-left: 20px; top: 25%; left: 100%;" v-if="isTimeSlider">
        <img class="clock-img" width="76" :src="resolveAssetPath('Clock_BG.png', 'ui/RedU')" />
        <svg class="clock-img" width="76" height="76">
          <circle v-if="value == maxValue" cx="38" cy="38" r="31.8" fill="#e9714c"/>
          <path v-else :d="arcDAttribute" fill="#e9714c" stroke-width="0" />
        </svg>
        <img class="clock-img" width="76" :src="resolveAssetPath('Clock_numbers.png', 'ui/RedU')" />
        <img class="clock-img" width="76" :style="minuteHandStyle" :src="resolveAssetPath('Clock_Hand.png', 'ui/RedU')" />
        <img class="clock-img" width="76" :style="hourHandStyle" :src="resolveAssetPath('Clock_Hand.png', 'ui/RedU')" />
      </div>
      <span v-else-if="!displayValueOnTop && !(choice && (choice.sliderHideValue || choice.sliderDisplayValueOnThumb))"
        class="value-string-container"
        :style="{
          'text-align': (choice && choice.sliderDisplayValueAlign) ? choice.sliderDisplayValueAlign : 'left',
        }"
      ><span ref="valueStringContainer" :class="`${currency ? 'currency' : ''}`">{{valueString}}</span></span>
    </div>
  </div>
</template>

<script>
import fitty from 'fitty';

export default {
  model: {
    prop: 'modelValue'
  },
  props: {
    /** for showing no input until a user clicks on it */
    noThumbOrFill: { type: Boolean, default: false },
    notRounded: { type: Boolean, default: false },
    clock: { type: Boolean, default: false },
    displayValueOnTop: { type: Boolean, default: false },
    currency: { type: Boolean, default: false },
    sliderMin: { type: Number, default: 0 },
    sliderClamp: { type: Number, default: Infinity },
    sliderMax: { type: Number, default: 1 },
    displayIntervals: { type: Boolean, default: false },
    sliderInterval: { type: Number, default: 0 },
    backgroundColor: { type: String, default: undefined },
    sliderStyle: { type: String, default: undefined },
    titleAlign: { type: String, default: 'center' },
    titleHeight: { type: String, default: '30px' },
    color: { type: String, default: 'magenta' },
    title: { type: String, default: 'New Slider' },

    decision: { type: Object },
    choice: { type: Object },
    single: { type: Boolean, default: false },
    idx: { type: Number, default: 0 },
    width: { type: String, default: '356px' },
    modelValue: { type: Number, default: 0 }
  },

  data() {
    return {
      intermediateValue: 0,
      fit: undefined
    };
  },

  computed: {
    hourHandStyle() {
      const hours = this.value / 60;
      const angle = hours % 12 * 360 / 12;
      return `transform: rotate(${angle}deg) scale(0.75);`;
    },
    minuteHandStyle() {
      const minutes = this.value;
      const angle = minutes % 60 * 360 / 60;
      return `transform: rotate(${angle}deg);`;
    },
    arcDAttribute() {
      const minutes = this.value;
      const angle = minutes % 60 * 360 / 60 - 90;
      const endAngleRad = (angle * Math.PI) / 180;
      const largeArcFlag = (angle < 90 ? '0' : '1');

      const radius = 31.8;
      const endX = Math.cos(endAngleRad) * radius;
      const endY = radius + (Math.sin(endAngleRad) * radius);
      return `M38,38 v-${radius} a${radius}, ${radius} 0 ${largeArcFlag},1 ${endX},${endY} z`;
    },
    value: {
      get() {
        const temp = this.intermediateValue;
        if (typeof (temp) === 'number') return temp;

        const result = parseFloat(temp);
        if (!result || isNaN(result)) { return 0; }
        return result;
      },
      set(value) {
        this.modelValue = value;
        this.$emit('input', value);
        this.intermediateValue = value;
      }
    },

    valueString() {
      return this.formatValueDisplay(this.value);
    },

    isTimeSlider() {
      return this.clock;
    },

    displayTimes() {
      const times = [];
      for (let i = this.minValue; i <= this.maxValue; i += this.displayInterval) {
        times.push(this.formatValueDisplay(i));
      }
      return times;
    },

    // Note that all times are expressed in minutes
    displayInterval() {
      return this.sliderInterval;
    },

    shouldDisplayIntervals() {
      return this.sliderInterval > 0 && this.displayIntervals;
    },

    minValue() {
      return this.sliderMin;
    },

    maxValue() {
      return this.sliderMax;
    },

    thumbDisplayValueStyle() {
      let style = {};
      if (this.choice.sliderDisplayValueStyle) {
        try {
          style = JSON.parse(this.choice.sliderDisplayValueStyle);
        } catch (ex) {
          console.error('failed to parse slider thumb display value style');
          console.error(this.choice.sliderDisplayValueStyle);
          console.error(ex);
          style = {};
        }
      }
      style.visibility = this.noThumbOrFill ? 'hidden' : undefined;
      style.left = `calc(${
        100 * (this.value - this.minValue) / Math.max(1, (this.maxValue - this.minValue))
      }% + ${
        13 - ((26 * (this.value - this.minValue) / Math.max(1, (this.maxValue - this.minValue))))
      }px)`;
      return style;
    },

    thumbDisplayValueFlippedRootStyleFix() {
      if (this.thumbDisplayValueStyle
        && this.choice.sliderDisplayValueOnThumb
        && !(this.choice.sliderHideValue)
        && (this.choice.sliderLabelsBelow)) {
        const height = this.thumbDisplayValueStyle.height;
        const fontSize = this.thumbDisplayValueStyle['font-size'];
        if (height && fontSize) {
          return `max(${fontSize} - 12px, ${height} + 4px)`;
        } else if (fontSize) {
          return `calc(${fontSize} - 12px)`;
        } else if (height) {
          return `calc(${height} + 4px)`;
        }
      }
      return '';
    }
  },

  watch: {
    modelValue() {
      this.$nextTick(() => this.handleSliderInput(true));
    },
    minValue() {
      this.$nextTick(() => this.handleSliderInput(true));
    },
    maxValue() {
      this.$nextTick(() => this.handleSliderInput(true));
    }
  },

  methods: {
    // shouldDisplayIntervals
    formatValueDisplay(value) {
      if (this.isTimeSlider) {
        const minutes = value;
        const hours = Math.floor(minutes / 60);
        /** @type {Number} */
        const remainingMinutes = Math.floor(minutes - hours * 60);
        return `${hours.toString().padStart(2, '0')}:${remainingMinutes.toString().padStart(2, '0')}`;
      } else if (this.currency) {
        const rendered = Math.floor(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return `${rendered}`;
      }
      return value;
    },

    // Slider
    handleSliderInput(ignoreEmit) {
      this.$nextTick(() => { if (this.fit) { this.fit.fit(); } });

      const slider = this.$refs.choiceSlider;
      if (this.sliderClamp < slider.value) {
        // alert(`clamping to ${this.sliderClamp}`);
        console.log(`clamping to ${this.sliderClamp}`);
        slider.value = this.sliderClamp;
        this.value = slider.value;
      }

      // Added this offset because for some reason, the ends of the slider color went a bit too far
      // or a bit too short at the ends
      const offset = 0.03;
      const diff = slider.max - slider.min;
      const value = diff === 0 ? 0 :
        (((slider.value - slider.min) / (diff)) * (1 - offset) + offset / 2)
        * 100;

      console.log(`value: ${value}, clamping to ${this.sliderClamp}`);

      // if (this.idx === 0) { console.log(`value: ${value}, interval: ${this.displayInterval}`); }
      let startColor = 'var(--primaryColor)';
      if (this.color) {
        startColor = this.color;
      } else {
        switch (this.idx % 4) {
          case 1:
            startColor = 'green';
            break;
          case 2:
            startColor = 'blue';
            break;
          case 3:
            startColor = 'cyan';
            break;
          default:
            break;
        }
      }

      const endColor = '#E7E7E7';
      slider.style.background = `linear-gradient(to right, ${startColor} 0%, ${startColor} ${value}%, ${endColor} ${value}%, ${endColor} 100%)`;

      if (!ignoreEmit) {
        this.$emit('input', this.value);
      }
    },

    async initialize() {
      if (this.decision.type === 'sliders') {
        this.value = (this.choice.sliderValue && parseFloat(this.choice.sliderValue))
          || this.choice.sliderDefault;
        // clamp
        if (this.choice.sliderMin != null) this.value = Math.max(this.choice.sliderMin, this.value);
        if (this.choice.sliderMax != null) this.value = Math.min(this.choice.sliderMax, this.value);
      } else {
        this.value = this.modelValue;
      }

      await new Promise(resolve => setTimeout(resolve, 1));

      while (!this.$refs.choiceSlider) await this.$nextTick();
      this.handleSliderInput(true);
    }
  },

  async mounted() {
    await this.initialize();

    if (!this.isTimeSlider && this.$refs.valueStringContainer) {
      console.log('fitty created');
      this.fit = fitty(
        this.$refs.valueStringContainer,
        { minSize: 10, maxSize: 20, multiLine: false }
      );
    }
  },

  beforeDestroy() {
    if (this.fit) {
      this.fit.unsubscribe();
      this.fit = undefined;
    }
  }
};
</script>

<style lang="scss" scoped>
.colored-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 26px;
  height: 26px;
  border: 1px solid grey;
  border-radius: 50%;
  background: #eeeeee;
  cursor: pointer;
}

.colored-slider::-moz-range-thumb {
  width: 25px;
  height: 25px;
  border: 1px solid grey;
  border-radius: 50%;
  background: #eeeeee;
  cursor: pointer;
}

.colored-slider {
  background: linear-gradient(
    to right,
    /* Start color */
    var(--primaryColor) 0%, var(--primaryColor) 50%,
    /* End color */
    #fff 50%, #fff 100%
  );

  border: solid 1px #82CFD0;
  border-radius: 8px;
  height: 16px;
  width: 356px;
  outline: none;
  transition: background 450ms ease-in;
  -webkit-appearance: none;
}

.no-thumb-or-fill {
  background: #E7E7E7 !important;
}

.no-thumb-or-fill::-webkit-slider-thumb {
  visibility: hidden !important;
  cursor: unset !important;
}

.no-thumb-or-fill::-moz-range-thumb {
  visibility: hidden !important;
  cursor: unset !important;
}

.thumb-display-value {
  padding: 0 4px;
  min-width: 39px;
  max-width: 250px;
  min-height: 24px;
  max-height: 50px;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 16px;
  // font-weight: bold;
  background-image: linear-gradient(bottom, var(--choiceButtonColor) 0%, var(--choiceButtonColorLightened) 100%);
  background-image: -o-linear-gradient(bottom, var(--choiceButtonColor) 0%, var(--choiceButtonColorLightened) 100%);
  background-image: -moz-linear-gradient(bottom, var(--choiceButtonColor) 0%, var(--choiceButtonColorLightened) 100%);
  background-image: -webkit-linear-gradient(bottom, var(--choiceButtonColor) 0%, var(--choiceButtonColorLightened) 100%);
  background-image: -ms-linear-gradient(bottom, var(--choiceButtonColor) 0%, var(--choiceButtonColorLightened) 100%);
  background-image: -webkit-gradient(linear,
      left bottom,
      left top,
      color-stop(0, var(--choiceButtonColor)),
      color-stop(1, var(--choiceButtonColorLightened)));
  color: var(--choiceButtonTextColor);
  display: block;
  position: absolute;
  left: 50%;
  top: 4px;
  transform: translate(-50%, 0);
  border-radius: 6px;
}

.thumb-display-value.flip {
  top: unset;
  bottom: 8px;
}

.thumb-display-value:before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-bottom: 8px solid var(--choiceButtonColorLightened);
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  bottom: 100%;
  left: 50%;
  margin-left: -4px;
  margin-bottom: -1px;
}

.thumb-display-value.flip:before {
  border-bottom: none;
  border-top: 8px solid var(--choiceButtonColor);
  top: 100%;
  margin-top: -1px;
}

.clock-img
{
  position: absolute;
}

.value-string-container
{
  display: inline-block;
  white-space: nowrap;
  width: 100%;
}

.label-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/ChoiceSlider.vue